import type { Signal } from '@thom/folio-domain/core/ports/live'
import { filterFor } from '@thom/pb/filter-builder'
import { COLLECTION } from './interviews-adapter'
import type { Realtime } from './realtime'

const byId = (id: string) => filterFor<{ id: string }>()([{ field: 'id', comparator: 'eq', value: id }])

const createInterviewSignal = ({ client, connection }: Realtime): Signal<string> => ({
	source: { client, collection: COLLECTION, map: record => record, connection },
	options: id => ({ filter: byId(id), perPage: 1 }),
})

export { createInterviewSignal }
